import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ListType } from '../../../contact-setting/models/list-type.model';
import { EventEmitterService } from '../../../shared/services/event-emitter.service';
import { ReportBuilderUtil as reportUtil } from '../../../report-builder/report-builder.util';

@Component({
  selector: 'kt-edit-y-entity-field',
  templateUrl: './edit-y-entity-field.component.html',
  styleUrls: ['./edit-y-entity-field.component.scss']
})
export class EditYEntityFieldComponent implements OnInit {

  public editYEntityFieldForm: FormGroup;
  editYVal:any;
  fieldName:string;
  label:string;
  measureTypeList:ListType[];
  public measureValueType: FormControl = new FormControl();
  valuelist:any;
  reportType:string|number;
  isFirstOpen:boolean;
  maxLabelLength: number = 50;
  isMeasureControlRequiredFlag: boolean=false;
  public displayDateGroupBy:boolean=false;
  public dateGroupByList=new Array<ListType>();

  constructor(private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    public eventEmitterService: EventEmitterService) { }

  ngOnInit(): void {
   // console.log('editt field----------------')
  ///  console.log(this.editYVal);
  //  console.log('value loist**************************');
  //  console.log(this.valuelist);
    this.initeditEntityFieldForm();
    this.getMeasureList();
    this.fieldName=this.editYVal.entityFieldName;
    this.isMeasureControlRequiredFlag=this.isMeasureControlRequired();
    if(this.editYVal.label =='' || this.editYVal.label == undefined){
      this.label=this.editYVal.entityFieldName;
    }else{
      this.label=this.editYVal.label;
    }
 //   console.log('this.fieldName------'+this.fieldName);
 //   console.log('this.label---'+this.label);
    if((this.reportType ==1 || this.reportType ==3 || this.reportType ==4 ||this.reportType ==5 ||this.reportType ==6) && this.editYVal.aggFunc !=null && this.editYVal.aggFunc !=''){
      let msr: any = this.measureTypeList.find(x => x.value == this.editYVal.aggFunc);
      msr = msr ? msr.id : null;
      this.editYEntityFieldForm.controls['measure'].setValue(msr);
    }
   // this.editEntityFieldForm.controls['label'].setValue(this.editVal.entityFieldName);
   if(this.editYVal.entityFieldType.id==3 && (this.reportType==2||this.reportType==6)){
    
    this.displayDateGroupBy=true;
    this.dateGroupByList.push({id:1,value:'Date'});
    this.dateGroupByList.push({id:2,value:'Week'});
    this.dateGroupByList.push({id:3,value:'Month'});
    this.dateGroupByList.push({id:4,value:'Year'});
    this.editYEntityFieldForm.controls['dateGroupBy'].setValue(this.editYVal.dateGroupBy?this.editYVal.dateGroupBy:1);
    this.editYEntityFieldForm.controls['dateGroupBy'].setValidators([Validators.required]);
   }
  }

  initeditEntityFieldForm(){
    this.editYEntityFieldForm = this.fb.group({
      fieldName:[{value: '', disabled: true}],
      label: ['', Validators.compose([Validators.required,Validators.maxLength(this.maxLabelLength) ])],
      measure:[],
      dateGroupBy:[''],
     });
     if ((this.reportType === 3 || this.reportType === 6) || ([1, 4, 5].includes(+this.reportType) && [3, 7].includes(this.editYVal.entityFieldType.id))) {
      this.editYEntityFieldForm.get('measure').setValidators([Validators.required]);
    }
  }

  changeMeasureType(val){
    const oldLabel: string = this.editYEntityFieldForm.get('label').value;
    const newLabel = reportUtil.getNewLabelOnMeasureChange(oldLabel, val, this.measureTypeList);
    this.editYEntityFieldForm.get('label').setValue(newLabel);
  }

  getMeasureList(){
    this.measureTypeList= new Array<ListType>();

    if(this.editYVal.entityFieldType.id == 7){
      this.measureTypeList.push({ id: 1, value:"sum"});
      this.measureTypeList.push({ id: 2, value:"average"});
      this.measureTypeList.push({ id: 3, value:"count"});
      this.measureTypeList.push({ id: 4, value:"min"});
      this.measureTypeList.push({ id: 5, value:"max"});
     }
     else if(this.editYVal.entityFieldType.id == 3){
      this.measureTypeList.push({ id: 3, value:"count"});
      this.measureTypeList.push({ id: 4, value:"min"});
      this.measureTypeList.push({ id: 5, value:"max"});
     }
     else{
      this.measureTypeList.push({ id: 3, value:"count"});
     }
  }

  Close(){
    this.activeModal.close();
    this.editYEntityFieldForm.reset();
    // if(this.isFirstOpen === true) {
    //   this.Delete();
    // }
  }

  Save(){
    const controls = this.editYEntityFieldForm.controls;

		if (this.editYEntityFieldForm.invalid) {
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);
			return;
		}
    const CopyOfEditYVal = {...this.editYVal};

    CopyOfEditYVal.measure=controls.measure.value;
    if(CopyOfEditYVal.measure !=null && CopyOfEditYVal.measure !=''){
      if(CopyOfEditYVal.measure == 1)
            CopyOfEditYVal.aggFunc='sum';
      else if(CopyOfEditYVal.measure == 2)
            CopyOfEditYVal.aggFunc='average';
      else if(CopyOfEditYVal.measure == 3)
            CopyOfEditYVal.aggFunc='count';
      else if(CopyOfEditYVal.measure == 4)
            CopyOfEditYVal.aggFunc='min';
      else if(CopyOfEditYVal.measure == 5)
            CopyOfEditYVal.aggFunc='max';
    }else{
            CopyOfEditYVal.aggFunc=null;
    }
    CopyOfEditYVal.label=controls.label.value;
    if(CopyOfEditYVal.entityFieldType.id==3 && (this.reportType==2||this.reportType==6)){
      CopyOfEditYVal.dateGroupBy=controls.dateGroupBy.value;
    }
    //console.log(CopyOfEditYVal.measure);
    this.activeModal.close(CopyOfEditYVal);
    this.editYEntityFieldForm.reset();
    this.eventEmitterService.onModalCloseResult(CopyOfEditYVal);
   // this.activeModal.close();
   // this.editEntityFieldForm.reset();

  }

  Delete(){
    const index = this.valuelist.indexOf(this.editYVal);
  //  console.log('index---'+index);
   if(index !== -1) {
    this.valuelist.splice(index, 1);
   }
    this.activeModal.close("Deleted");
    this.editYEntityFieldForm.reset();
   // this.eventEmitterService.onModalCloseResult(index);
   this.eventEmitterService.onModalCloseResult(this.valuelist);
  }
  
  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.editYEntityFieldForm.controls[controlName];
      if (!control) {
        return false;
      }
      
      const result = control.hasError(validationType) && (control.dirty || control.touched);
      return result;
  }

  isMeasureControlRequired(): boolean {
    if ((this.reportType === 3 || this.reportType === 6) || ([1, 4, 5].includes(+this.reportType) && [3, 7].includes(this.editYVal.entityFieldType.id)))
    {return true;}
  return false
  }

}
